
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { handleAllErrors } from '@/utils/errorHandling';
import Order from '@/components/profile/Order.vue';

const namespace: string = 'auth';

@Component<PastOrders>({
	components: {
		Order
	}
})
export default class PastOrders extends Vue {
	@Action('getPastOrders', { namespace }) private getPastOrders!: (payload: PastOrdersPayload) => Promise<PastOrdersResponse>;
	@Getter('getUser', { namespace }) private user!: UserInfo;
	@Getter('showLoginAsBanner', { namespace }) private showLoginAsBanner!: boolean;

	private readonly pageSize: number = 20;

	private orders: ReceiptInfo[] = [];
	private totalOrders: number = 0;

	private dataFetched: boolean = false;
	private isAnyLoading: boolean = false;
	private isLoadingMore: boolean = false;

	private mounted(): void {
		this.fetchOrders();
	}

	/**
	 * Redirect to the profile page
	 *
	 * @return {void}
	 */
	private toProfile(): void {
		this.$router.push({ path: '/profile', query: this.$route.query, hash: this.$route.hash }).catch(() => {});
	}

	/**
	 * Fetch past orders of the user
	 *
	 * @return {Promise<void>}
	 */
	private async fetchOrders(): Promise<void> {
		try {
			const response = await this.getPastOrders({
				userId: this.user.id,
				token: this.user.token,
				limit: this.pageSize,
				offset: 0
			});
			this.orders = response.orders;
			this.totalOrders = response.total;
		}
		catch (error) {
			handleAllErrors(this.$t('profile.past_orders.error_fetch_orders'), error);
		}
		finally {
			this.dataFetched = true;
		}
	}

	/**
	 * Load more past orders
	 *
	 * @return {Promise<void>}
	 */
	private async loadMore(): Promise<void> {
		this.isLoadingMore = true;

		try {
			const response = await this.getPastOrders({
				userId: this.user.id,
				token: this.user.token,
				limit: this.pageSize,
				offset: this.orders.length
			});
			this.orders = [...this.orders, ...response.orders];
			this.totalOrders = response.total;
		}
		catch (error) {
			handleAllErrors(this.$t('profile.past_orders.error_fetch_orders'), error);
		}
		finally {
			this.isLoadingMore = false;
		}
	}
}
